import { host,loginHost } from "./config";
import { message } from "antd";
const $={
	createXHR(){
		if(window.XMLHttpRequest) {
			return new window.XMLHttpRequest()
		} else {
			return new window.ActiveXObject()
		} 
	},
    formsParams(data){
        let arr = [];
        for(let key in data){
            if(data[key]!=null){
                arr.push(key + "=" + data[key]);
            }
        };
        if(arr.length>0){
           return "?"+arr.join("&"); 
        }else{
            return "";
        }
      
    },
	ajax(params) {
		console.log('localStorage.getItem("token")',localStorage.getItem("token"))
		let hostApi = params.api==='login-api'?loginHost:host
		let type = params.type ? params.type.toLowerCase() : 'get';
		let isAsync = params.isAsync ? params.isAsync : 'true';
		let url =`${hostApi}${params.url}`;
		let token = params.token?localStorage.getItem("token"):"";
		console.log(token)
		let tip=params.tip||false;
		let data = params.data|| {};
		let dataType = params.dataType?params.dataType.toLowerCase():'json';
		let xhr = this.createXHR();
		return new Promise((resolve, reject) => {
			if (type === 'post' || type === 'delete' || type === 'put') {
        xhr.open(type, url, isAsync);
				xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader("token",token);
				xhr.send(JSON.stringify(data))
			} else {
				xhr.open(type, url+this.formsParams(data), isAsync);
				xhr.setRequestHeader("token",token);
				xhr.send()
			}
			xhr.onreadystatechange = ()=>{
				if(xhr.readyState === 4) {
					let res = dataType === 'json' ? JSON.parse(xhr.responseText) : xhr.responseText;
					if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
						if (res.code === 401) {
							message.warning("登录信息过期！");
							//window.location.href="/login"
						} else {
							resolve(res) // 网络请求成功，返回结果
							tip && message.success(res.msg);
						}		
						
					} else if (xhr.status === 500 && res.code === 401) {
						message.warning("登录信息过期！");
						//window.location.href="/login"
					} else {
						message.error(res.msg);
						reject(xhr.status) // 请求失败，没有返回
					}
				}
			}
		})	
	}
}
export default $;